import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { format } from 'date-fns';
import { ClrModal } from '@clr/angular';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';


@Component({
    selector: 'app-locais-fornecedores',
    templateUrl: './fornecedores.component.html',
    styleUrls: ['./fornecedores.component.css'],
    styles: [`
    .mat-dialog-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      background-color: #fff;
    }
  `],
    standalone: false
})

export class FornecedoresComponent {
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: '',
    nomeContato: '',
    telefone: '',
    descarga: false
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'Fornecedores_Karrara_Transport';
  queryUsers: string = 'usersPortal';
  data: any;
  base: number = 3;
  ID: number = Date.now();
  local: string = "";
  contato: string = "";
  endereco: string = "";
  localDescarga: string = "";
  nomeContato: string = '';
  telefone: string = '';
  comentario: string = "";
  exponent: number = 22;
  $even: any;
  $odd: any;
  dataSource: any;
  dialogRef: any;
  items$!: Observable<any[]>;
  items: any[] = [];
  name!: string;
  animal!: string;
  dialogOpen = false;
  isLoading: boolean = true;
  campoTocado: boolean = false;
  usuarioLogado: any;

  
  
  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private autenticacaoService: AutenticacaoService,
  ) {

  }

  editDialog(item: any): void {
    //console.log(item)
    this.item.ID = item.ID
    this.item.local = item.local;
    this.item.contato = item.contato;
    this.item.endereco = item.endereco;
    this.item.localDescarga = item.localDescarga;
    this.item.latitude = item.latitude;
    this.item.longitude = item.longitude;
    this.item.descarga = item.descarga;
    this.item.nomeContato = item.nomeContato;
    this.item.telefone = item.telefone;
    this.dialogOpen = true;
  }
  
  onFieldTouched() {
    this.campoTocado = true;
  }
  
  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // //console.log("user logado")
    // //console.log(this.usuarioLogado)
    // if (this.usuarioLogado.id == null) {
    //   this.editDialog(this.items);
    // }
  }


  async salvar() {
    this.isLoading = true;
    if (this.item.local && this.item.latitude && this.item.longitude) {
      if (this.item.ID === undefined) {
        const currentDate = new Date();
        const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
        //console.log(formattedDate);
        this.item = {
          "ID": formattedDate.toString(),
          "contato": this.item.contato,
          "endereco": this.item.endereco,
          "localDescarga": this.item.localDescarga,
          "local": this.item.local,
          "latitude": this.item.latitude,
          "longitude": this.item.longitude,
          "descarga": this.item.descarga,
          "nomeContato": this.item.nomeContato,
          "telefone": this.item.telefone
        }
      }
      this.item.tableName = this.query
      // Remover as barras invertidas escapadas
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // //console.log(modifiedJsonString);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
        await this.getItemsFromDynamoDB();
        this.dialogOpen = false;
        this.isLoading = false;      
      }, error => {
        console.log(error);
      });
    } else {
      this.campoTocado = true;
      alert("Formulario incompleto!")
      this.isLoading = false;
    }
  }

  cancel(): void {
    this.dialogOpen = false;
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
  
  async ngOnInit(): Promise<void> {
    await this.getUserLogado();
    await this.getItemsFromDynamoDB();
    // await this.centerDialog();
    this.isLoading = false;
  }

  async getItemsFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.items = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              // Forçar detecção de alterações após atualizar os dados
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async deleteItem(ID: string, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este cadastro?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
        async response => {
          await this.getItemsFromDynamoDB();
          this.isLoading = false;
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }
}
